import { Collapsible } from '~/components/ui/Collapsible';
import { Terminal } from '~/components/workbench/terminal/Terminal';
import type { PotentialTerminalProblem } from '~/types/chat';

export function TerminalRenderer(error: PotentialTerminalProblem) {
  return (
    <div className="flex flex-col gap-2">
      <Collapsible
        defaultOpen={false}
        titleClassName="flex-col"
        title={
          <div className="[&>pre]:px-2 [&>pre]:py-2 text-xs w-full">
            <pre>
              <div className="flex items-center gap-1">
                <div className="text-lg i-ph:x text-bolt-elements-icon-error"></div>
                Terminal error
              </div>
            </pre>
          </div>
        }
      >
        <Terminal className="grow-1 h-[150px]" readonly>
          {error.output.trim()}
        </Terminal>
      </Collapsible>
    </div>
  );
}
